var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m12.92.437-8.854 9.997-2.987-3.371a.518.518 0 0 0-.775.686L4.062 12l9.634-10.876a.518.518 0 1 0-.775-.687Z"}));
}

Check.defaultProps = {"width":"14","height":"12","viewBox":"0 0 14 12","fill":"none"};

module.exports = Check;

Check.default = Check;
